import {
  REGISTER_USER,
  REGISTER_USER_SUCCESSFUL,
  REGISTER_USER_FAILED,
  SOCIAL_REGISTER_USER,
  SOCIAL_REGISTER_SUCCESSFUL
} from "./actionTypes"

export const registerUser = user => {
  return {
    type: REGISTER_USER,
    payload: { user },
  }
}

export const registerUserSuccessful = user => {
  return {
    type: REGISTER_USER_SUCCESSFUL,
    payload: user,
  }
}

export const registerUserFailed = user => {
  return {
    type: REGISTER_USER_FAILED,
    payload: user,
  }
}
export const socialSignup = (data, type,history) => {
  return {
    type:SOCIAL_REGISTER_USER,
    payload: { data, type,history },
  }
}

export const socialSignupSuccessful = data => {
  return {
    type: SOCIAL_REGISTER_SUCCESSFUL,
    payload: data,
  }
}